import { Tooltip } from "./Tooltip";

export default Tooltip;
